export const uaeIPRanges = [
    "2.48.0.0/14",
    "2.56.16.0/22",
    "2.56.36.0/22",
    "2.56.136.0/22",
    "2.56.240.0/22",
    "2.57.16.0/22",
    "2.57.20.0/22",
    "2.57.148.0/22",
    "2.57.240.0/22",
    "2.58.28.0/22",
    "2.58.96.0/22",
    "2.58.172.0/22",
    "2.59.0.0/22",
    "2.59.40.0/22",
    "2.59.212.0/22",
    "5.30.0.0/15",
    "5.32.0.0/17",
    "5.35.32.0/21",
    "5.38.0.0/17",
    "5.44.253.0/24",
    "5.45.36.0/22",
    "5.53.96.0/21",
    "5.83.112.0/21",
    "5.107.0.0/16",
    "5.133.108.0/22",
    "5.152.248.0/21",
    "5.160.0.0/16",
    "5.180.16.0/22",
    "5.181.13.0/24",
    "5.181.14.0/23",
    "5.181.124.0/22",
    "5.181.128.0/22",
    "5.181.132.0/22",
    "5.182.24.0/22",
    "5.182.108.0/22",
    "5.182.124.0/22",
    "5.183.152.0/22",
    "5.187.32.0/24",
    "5.192.0.0/15",
    "5.194.0.0/17",
    "5.194.128.0/18",
    "5.194.192.0/19",
    "5.194.224.0/20",
    "5.194.240.0/21",
    "5.194.248.0/22",
    "5.194.252.0/22",
    "5.195.0.0/16",
    "5.252.68.0/22",
    "5.252.72.0/22",
    "5.252.76.0/22",
    "5.252.80.0/22",
    "5.252.160.0/22",
    "5.253.200.0/22",
    "23.130.28.0/24",
    "31.14.10.0/24",
    "31.24.253.0/24",
    "31.29.64.0/19",
    "31.41.38.0/24",
    "31.41.39.0/24",
    "31.56.0.0/14",
    "31.215.0.0/16",
    "31.218.0.0/15",
    "37.140.216.0/24",
    "37.140.247.0/24",
    "37.143.60.0/22",
    "37.153.158.0/24",
    "37.156.5.0/24",
    "37.202.192.0/19",
    "37.218.224.0/21",
    "37.236.0.0/14",
    "37.245.0.0/16",
    "43.225.52.0/22",
    "45.8.88.0/22",
    "45.8.156.0/22",
    "45.8.228.0/22",
    "45.10.108.0/22",
    "45.10.172.0/23",
    "45.11.24.0/22",
    "45.11.160.0/22",
    "45.11.212.0/22",
    "45.13.248.0/22",
    "45.15.72.0/22",
    "45.15.172.0/22",
    "45.65.116.0/22",
    "45.66.244.0/22",
    "45.67.60.0/22",
    "45.80.220.0/22",
    "45.81.0.0/22",
    "45.81.24.0/22",
    "45.82.40.0/22",
    "45.82.80.0/22",
    "45.83.96.0/22",
    "45.85.64.0/22",
    "45.85.108.0/22",
    "45.86.168.0/22",
    "45.87.48.0/22",
    "45.87.120.0/23",
    "45.87.184.0/22",
    "45.87.216.0/22",
    "45.88.8.0/22",
    "45.88.12.0/22",
    "45.88.80.0/22",
    "45.88.96.0/22",
    "45.88.208.0/22",
    "45.89.228.0/22",
    "45.89.240.0/22",
    "45.89.248.0/22",
    "45.89.252.0/22",
    "45.91.160.0/22",
    "45.91.164.0/22",
    "45.92.172.0/22",
    "45.93.44.0/22",
    "45.93.82.0/23",
    "45.93.200.0/23",
    "45.93.202.0/24",
    "45.94.20.0/22",
    "45.94.96.0/22",
    "45.95.12.0/22",
    "45.95.20.0/22",
    "45.95.36.0/22",
    "45.95.64.0/22",
    "45.114.60.0/22",
    "45.129.140.0/23",
    "45.129.168.0/22",
    "45.129.236.0/22",
    "45.130.64.0/22",
    "45.130.144.0/22",
    "45.130.148.0/22",
    "45.131.44.0/22",
    "45.131.48.0/22",
    "45.132.16.0/22",
    "45.132.204.0/22",
    "45.133.28.0/22",
    "45.133.32.0/22",
    "45.133.168.0/22",
    "45.133.172.0/22",
    "45.133.176.0/22",
    "45.133.216.0/22",
    "45.133.232.0/22",
    "45.134.12.0/22",
    "45.134.24.0/22",
    "45.134.28.0/22",
    "45.134.252.0/22",
    "45.135.128.0/22",
    "45.135.132.0/22",
    "45.135.164.0/22",
    "45.135.176.0/22",
    "45.135.180.0/22",
    "45.135.232.0/22",
    "45.136.68.0/22",
    "45.136.100.0/22",
    "45.136.204.0/22",
    "45.136.244.0/22",
    "45.136.248.0/22",
    "45.137.28.0/22",
    "45.137.52.0/22",
    "45.137.116.0/22",
    "45.137.124.0/22",
    "45.137.132.0/22",
    "45.137.152.0/22",
    "45.137.156.0/22",
    "45.137.188.0/22",
    "45.138.0.0/22",
    "45.138.144.0/22",
    "45.139.0.0/22",
    "45.139.28.0/22",
    "45.139.176.0/23",
    "45.139.178.0/24",
    "45.139.180.0/22",
    "45.140.16.0/22",
    "45.140.60.0/22",
    "45.140.168.0/22",
    "45.140.172.0/22",
    "45.141.92.0/22",
    "45.141.100.0/22",
    "45.141.184.0/22",
    "45.141.196.0/22",
    "45.142.44.0/22",
    "45.142.72.0/22",
    "45.142.212.0/22",
    "45.143.92.0/22",
    "45.143.140.0/22",
    "45.143.160.0/22",
    "45.144.24.0/22",
    "45.144.36.0/22",
    "45.144.172.0/22",
    "45.144.176.0/22",
    "45.145.0.0/22",
    "45.145.38.0/24",
    "45.145.52.0/22",
    "45.145.88.0/22",
    "45.145.160.0/22",
    "45.145.168.0/22",
    "45.146.36.0/22",
    "45.146.40.0/22",
    "45.146.168.0/22",
    "45.146.228.0/22",
    "45.147.0.0/22",
    "45.147.192.0/22",
    "45.147.200.0/22",
    "45.147.244.0/22",
    "45.147.252.0/22",
    "45.148.28.0/22",
    "45.148.64.0/22",
    "45.148.140.0/22",
    "45.148.164.0/23",
    "45.148.166.0/24",
    "45.148.240.0/22",
    "45.149.60.0/22",
    "45.149.80.0/22",
    "45.149.84.0/22",
    "45.149.132.0/22",
    "45.149.164.0/22",
    "45.150.20.0/22",
    "45.150.48.0/22",
    "45.150.60.0/22",
    "45.150.208.0/22",
    "45.151.144.0/22",
    "45.152.134.0/24",
    "45.152.135.0/24",
    "45.152.212.0/22",
    "45.152.224.0/22",
    "45.153.48.0/22",
    "45.153.52.0/22",
    "45.153.68.0/22",
    "45.153.224.0/22",
    "45.153.228.0/22",
    "45.154.160.0/22",
    "45.155.60.0/22",
    "45.155.156.0/22",
    "45.156.148.0/22",
    "45.158.44.0/22",
    "45.159.180.0/24",
    "45.159.182.0/23",
    "45.177.236.0/22",
    "45.183.4.0/22",
    "45.191.164.0/22",
    "45.231.206.0/23",
    "46.16.33.0/24",
    "46.17.248.0/21",
    "46.18.104.0/24",
    "46.19.72.0/21",
    "46.21.240.0/22",
    "46.29.39.0/24",
    "46.31.70.0/24",
    "46.102.237.0/24",
    "46.149.72.0/21",
    "46.149.96.0/24",
    "46.151.24.0/21",
    "46.174.142.0/23",
    "46.209.0.0/16",
    "46.243.0.0/21",
    "46.253.140.0/24",
    "62.84.96.0/21",
    "62.106.86.0/24",
    "62.122.184.0/24",
    "62.133.52.0/22",
    "62.182.168.0/21",
    "62.192.152.0/24",
    "65.20.128.0/17",
    "66.116.128.0/17",
    "66.220.48.0/22",
    "77.74.201.0/24",
    "77.81.65.0/24",
    "77.81.88.0/24",
    "77.81.100.0/24",
    "77.81.101.0/24",
    "77.81.182.0/24",
    "77.83.1.0/24",
    "77.83.2.0/23",
    "77.83.4.0/22",
    "77.83.72.0/22",
    "77.83.80.0/22",
    "77.83.92.0/22",
    "77.83.104.0/22",
    "77.94.0.0/23",
    "77.94.2.0/24",
    "77.104.64.0/18",
    "77.105.136.0/21",
    "77.110.64.0/18",
    "77.237.64.0/19",
    "77.238.224.0/19",
    "77.242.240.0/20",
    "77.243.82.0/23",
    "77.246.96.0/20",
    "78.40.192.0/21",
    "79.98.120.0/21",
    "79.110.227.0/24",
    "79.171.117.0/24",
    "79.171.118.0/23",
    "80.64.16.0/22",
    "80.64.20.0/23",
    "80.64.22.0/23",
    "80.64.24.0/21",
    "80.71.147.0/24",
    "80.74.24.0/21",
    "80.76.52.0/22",
    "80.76.60.0/22",
    "80.85.244.0/22",
    "80.227.0.0/16",
    "80.242.56.0/22",
    "80.242.60.0/22",
    "81.16.132.0/22",
    "81.16.140.0/22",
    "81.22.44.0/23",
    "81.25.68.0/22",
    "81.25.76.0/22",
    "82.178.32.0/23",
    "82.178.158.0/23",
    "82.205.128.0/22",
    "82.205.132.0/23",
    "82.205.202.0/23",
    "82.205.204.0/22",
    "82.205.208.0/20",
    "82.205.224.0/19",
    "83.97.96.0/21",
    "83.110.0.0/15",
    "83.150.220.0/22",
    "84.38.255.0/24",
    "84.54.4.0/22",
    "84.54.28.0/22",
    "84.54.52.0/22",
    "84.252.102.0/23",
    "85.8.184.0/22",
    "85.115.64.0/19",
    "85.117.232.0/22",
    "85.202.84.0/22",
    "85.202.164.0/22",
    "85.204.18.0/24",
    "85.204.22.0/24",
    "85.208.72.0/22",
    "85.209.8.0/22",
    "85.209.104.0/22",
    "85.209.176.0/22",
    "86.62.16.0/22",
    "86.96.0.0/14",
    "86.105.4.0/24",
    "86.106.26.0/24",
    "86.107.50.0/23",
    "86.107.100.0/24",
    "86.107.101.0/24",
    "86.107.168.0/24",
    "87.200.0.0/15",
    "87.247.140.0/22",
    "87.247.156.0/22",
    "88.210.3.0/24",
    "88.210.6.0/24",
    "88.210.9.0/24",
    "88.210.10.0/23",
    "88.210.12.0/23",
    "88.210.14.0/24",
    "88.210.20.0/23",
    "88.218.248.0/22",
    "89.19.44.0/22",
    "89.19.48.0/22",
    "89.34.106.0/24",
    "89.34.202.0/24",
    "89.34.219.0/24",
    "89.35.73.0/24",
    "89.35.119.0/24",
    "89.35.129.0/24",
    "89.35.130.0/23",
    "89.35.193.0/24",
    "89.36.137.0/24",
    "89.36.140.0/24",
    "89.37.185.0/24",
    "89.37.192.0/22",
    "89.39.120.0/23",
    "89.39.125.0/24",
    "89.40.36.0/24",
    "89.40.70.0/24",
    "89.40.215.0/24",
    "89.43.62.0/24",
    "89.44.76.0/24",
    "89.45.35.0/24",
    "89.45.44.0/23",
    "89.45.162.0/24",
    "89.46.42.0/24",
    "89.46.131.0/24",
    "89.47.36.0/24",
    "89.47.52.0/24",
    "89.47.55.0/24",
    "89.47.252.0/24",
    "89.150.34.0/23",
    "89.150.41.0/24",
    "89.150.59.0/24",
    "89.207.155.0/24",
    "90.156.144.0/22",
    "90.156.220.0/23",
    "91.72.0.0/14",
    "91.84.96.0/19",
    "91.102.120.0/21",
    "91.132.48.0/22",
    "91.132.56.0/22",
    "91.132.164.0/22",
    "91.132.224.0/24",
    "91.188.228.0/22",
    "91.191.180.0/22",
    "91.191.184.0/21",
    "91.194.149.0/24",
    "91.195.132.0/23",
    "91.198.220.0/24",
    "91.198.254.0/24",
    "91.200.12.0/22",
    "91.200.146.0/24",
    "91.201.4.0/22",
    "91.201.112.0/22",
    "91.202.211.0/24",
    "91.206.92.0/23",
    "91.207.236.0/24",
    "91.208.61.0/24",
    "91.209.162.0/23",
    "91.209.228.0/24",
    "91.209.230.0/23",
    "91.211.84.0/24",
    "91.212.49.0/24",
    "91.212.51.0/24",
    "91.212.53.0/24",
    "91.212.61.0/24",
    "91.212.65.0/24",
    "91.212.82.0/24",
    "91.213.29.0/24",
    "91.213.35.0/24",
    "91.213.49.0/24",
    "91.213.50.0/24",
    "91.213.99.0/24",
    "91.216.13.0/24",
    "91.216.59.0/24",
    "91.216.185.0/24",
    "91.217.125.0/24",
    "91.220.80.0/24",
    "91.220.81.0/24",
    "91.220.84.0/24",
    "91.220.90.0/24",
    "91.220.126.0/24",
    "91.220.157.0/24",
    "91.220.206.0/24",
    "91.220.223.0/24",
    "91.220.229.0/24",
    "91.221.38.0/23",
    "91.223.95.0/24",
    "91.224.22.0/23",
    "91.229.64.0/23",
    "91.229.90.0/23",
    "91.229.104.0/23",
    "91.229.116.0/22",
    "91.230.38.0/23",
    "91.230.41.0/24",
    "91.231.11.0/24",
    "91.231.187.0/24",
    "91.231.243.0/24",
    "91.234.254.0/23",
    "91.235.159.0/24",
    "91.235.235.0/24",
    "91.236.162.0/24",
    "91.239.227.0/24",
    "91.239.238.0/24",
    "91.240.33.0/24",
    "91.240.73.0/24",
    "91.245.224.0/22",
    "91.246.41.0/24",
    "92.62.119.0/24",
    "92.63.176.0/22",
    "92.63.180.0/22",
    "92.63.188.0/22",
    "92.96.0.0/14",
    "92.114.32.0/24",
    "92.114.54.0/24",
    "92.114.93.0/24",
    "92.118.160.0/22",
    "92.119.32.0/22",
    "92.119.128.0/22",
    "92.119.228.0/22",
    "92.242.184.0/22",
    "92.242.192.0/19",
    "92.246.76.0/22",
    "92.249.12.0/22",
    "93.90.74.0/23",
    "93.92.112.0/23",
    "93.92.114.0/24",
    "93.92.115.0/24",
    "93.93.207.0/24",
    "93.113.57.0/24",
    "93.113.171.0/24",
    "93.113.255.0/24",
    "93.114.183.0/24",
    "93.114.244.0/24",
    "93.115.104.0/22",
    "93.115.172.0/23",
    "93.115.175.0/24",
    "93.115.203.0/24",
    "93.118.36.0/24",
    "93.119.154.0/24",
    "93.119.195.0/24",
    "93.157.105.0/24",
    "93.177.125.0/24",
    "93.183.124.0/22",
    "93.190.125.0/24",
    "94.56.0.0/14",
    "94.101.111.0/24",
    "94.103.80.0/23",
    "94.103.82.0/24",
    "94.103.94.0/23",
    "94.103.182.0/24",
    "94.103.183.0/24",
    "94.103.184.0/24",
    "94.140.0.0/24",
    "94.154.140.0/22",
    "94.176.214.0/23",
    "94.177.13.0/24",
    "94.177.51.0/24",
    "94.177.106.0/24",
    "94.177.145.0/24",
    "94.177.147.0/24",
    "94.177.150.0/24",
    "94.198.171.0/24",
    "94.199.7.0/24",
    "94.200.0.0/13",
    "94.231.200.0/24",
    "94.232.248.0/22",
    "95.130.226.0/24",
    "95.130.227.0/24",
    "95.156.216.0/22",
    "103.21.58.0/23",
    "103.54.16.0/22",
    "103.71.20.0/22",
    "103.73.34.0/23",
    "103.74.92.0/22",
    "103.88.240.0/22",
    "103.90.72.0/22",
    "103.137.248.0/22",
    "103.141.68.0/23",
    "103.145.20.0/23",
    "103.152.182.0/23",
    "103.224.22.0/23",
    "103.245.228.0/22",
    "103.249.132.0/22",
    "109.69.56.0/21",
    "109.94.208.0/22",
    "109.94.216.0/22",
    "109.106.0.0/22",
    "109.177.0.0/16",
    "109.196.96.0/24",
    "109.196.97.0/24",
    "109.196.98.0/23",
    "109.196.100.0/22",
    "109.196.104.0/21",
    "109.196.164.0/22",
    "109.196.172.0/22",
    "109.205.24.0/21",
    "109.233.204.0/22",
    "109.234.33.0/24",
    "109.234.34.0/23",
    "109.234.36.0/22",
    "109.234.78.0/24",
    "114.129.44.0/24",
    "128.0.1.0/24",
    "128.0.41.0/24",
    "128.127.72.0/21",
    "130.185.120.0/22",
    "130.185.124.0/22",
    "130.255.0.0/21",
    "134.0.216.0/21",
    "138.128.224.0/22",
    "141.98.88.0/22",
    "141.105.160.0/21",
    "146.19.251.0/24",
    "146.103.96.0/19",
    "147.78.132.0/22",
    "148.222.120.0/22",
    "149.62.40.0/22",
    "149.255.192.0/18",
    "151.240.0.0/17",
    "151.240.128.0/17",
    "151.241.0.0/16",
    "151.242.0.0/17",
    "151.242.128.0/17",
    "151.243.0.0/17",
    "151.243.128.0/17",
    "151.244.0.0/16",
    "151.245.0.0/17",
    "151.245.128.0/17",
    "151.247.64.0/19",
    "151.248.96.0/20",
    "151.253.0.0/16",
    "158.255.77.0/24",
    "167.160.20.0/24",
    "169.224.0.0/17",
    "171.22.32.0/22",
    "176.53.160.0/22",
    "176.53.164.0/22",
    "176.53.184.0/22",
    "176.74.24.0/21",
    "176.74.48.0/21",
    "176.101.56.0/21",
    "176.113.64.0/22",
    "176.113.80.0/22",
    "176.118.164.0/22",
    "176.119.156.0/22",
    "176.126.174.0/24",
    "176.204.0.0/15",
    "176.223.66.0/24",
    "176.223.188.0/24",
    "178.22.8.0/21",
    "178.22.24.0/24",
    "178.23.185.0/24",
    "178.23.186.0/24",
    "178.23.187.0/24",
    "178.130.40.0/22",
    "178.217.102.0/24",
    "178.250.248.0/21",
    "179.61.128.0/17",
    "181.41.192.0/19",
    "181.214.0.0/15",
    "185.1.15.0/24",
    "185.3.152.0/22",
    "185.14.160.0/22",
    "185.16.24.0/24",
    "185.21.12.0/22",
    "185.21.140.0/22",
    "185.22.228.0/24",
    "185.26.24.0/22",
    "185.27.116.0/22",
    "185.31.188.0/22",
    "185.34.40.0/22",
    "185.34.101.0/24",
    "185.35.104.0/22",
    "185.37.192.0/22",
    "185.39.16.0/23",
    "185.39.19.0/24",
    "185.39.148.0/22",
    "185.42.12.0/22",
    "185.45.156.0/22",
    "185.45.192.0/24",
    "185.45.194.0/23",
    "185.47.166.0/24",
    "185.48.64.0/22",
    "185.51.152.0/22",
    "185.53.52.0/22",
    "185.53.248.0/24",
    "185.54.16.0/22",
    "185.56.88.0/22",
    "185.64.5.0/24",
    "185.66.16.0/22",
    "185.66.144.0/22",
    "185.68.20.0/22",
    "185.70.100.0/22",
    "185.71.204.0/22",
    "185.72.8.0/23",
    "185.76.128.0/22",
    "185.76.204.0/22",
    "185.78.244.0/22",
    "185.82.200.0/24",
    "185.82.202.0/24",
    "185.87.32.0/22",
    "185.88.11.0/24",
    "185.93.244.0/22",
    "185.95.140.0/22",
    "185.96.68.0/22",
    "185.101.144.0/22",
    "185.106.120.0/24",
    "185.106.122.0/23",
    "185.112.249.0/24",
    "185.113.250.0/24",
    "185.117.72.0/23",
    "185.117.228.0/22",
    "185.120.108.0/22",
    "185.121.232.0/22",
    "185.128.212.0/22",
    "185.130.204.0/22",
    "185.131.56.0/22",
    "185.135.8.0/22",
    "185.135.156.0/22",
    "185.137.12.0/22",
    "185.137.92.0/22",
    "185.139.0.0/22",
    "185.139.236.0/22",
    "185.141.12.0/22",
    "185.141.24.0/23",
    "185.141.27.0/24",
    "185.141.164.0/22",
    "185.141.216.0/22",
    "185.142.24.0/22",
    "185.143.228.0/22",
    "185.143.239.0/24",
    "185.145.36.0/22",
    "185.147.36.0/23",
    "185.147.38.0/24",
    "185.147.128.0/22",
    "185.148.24.0/22",
    "185.149.116.0/22",
    "185.149.122.0/24",
    "185.149.123.0/24",
    "185.151.4.0/22",
    "185.151.56.0/22",
    "185.151.147.0/24",
    "185.153.20.0/22",
    "185.155.240.0/22",
    "185.157.212.0/22",
    "185.158.100.0/22",
    "185.158.104.0/22",
    "185.158.132.0/22",
    "185.158.148.0/22",
    "185.159.84.0/24",
    "185.164.163.0/24",
    "185.167.218.0/24",
    "185.169.107.0/24",
    "185.170.40.0/22",
    "185.170.56.0/22",
    "185.170.140.0/22",
    "185.171.116.0/22",
    "185.172.56.0/22",
    "185.172.64.0/22",
    "185.173.24.0/22",
    "185.173.32.0/22",
    "185.174.60.0/22",
    "185.176.80.0/22",
    "185.179.196.0/22",
    "185.180.84.0/22",
    "185.183.97.0/24",
    "185.183.98.0/24",
    "185.184.20.0/22",
    "185.184.52.0/23",
    "185.184.77.0/24",
    "185.184.78.0/24",
    "185.184.152.0/22",
    "185.187.88.0/24",
    "185.187.196.0/23",
    "185.187.198.0/24",
    "185.189.165.0/24",
    "185.189.166.0/24",
    "185.189.192.0/23",
    "185.189.194.0/24",
    "185.189.252.0/22",
    "185.191.140.0/22",
    "185.191.212.0/22",
    "185.192.109.0/24",
    "185.192.110.0/24",
    "185.192.244.0/22",
    "185.193.100.0/22",
    "185.193.137.0/24",
    "185.193.138.0/24",
    "185.193.140.0/24",
    "185.193.142.0/23",
    "185.193.152.0/22",
    "185.194.104.0/23",
    "185.194.106.0/24",
    "185.195.168.0/24",
    "185.195.240.0/23",
    "185.195.242.0/24",
    "185.196.117.0/24",
    "185.196.118.0/24",
    "185.197.20.0/22",
    "185.198.36.0/22",
    "185.198.56.0/24",
    "185.198.58.0/23",
    "185.198.233.0/24",
    "185.198.234.0/23",
    "185.200.12.0/22",
    "185.200.52.0/22",
    "185.200.124.0/22",
    "185.200.170.0/24",
    "185.201.46.0/24",
    "185.201.100.0/22",
    "185.201.128.0/22",
    "185.201.192.0/22",
    "185.202.111.0/24",
    "185.203.228.0/22",
    "185.204.168.0/22",
    "185.209.49.0/24",
    "185.210.136.0/22",
    "185.211.56.0/22",
    "185.212.119.0/24",
    "185.215.232.0/22",
    "185.218.0.0/24",
    "185.219.52.0/22",
    "185.225.192.0/22",
    "185.225.240.0/22",
    "185.232.96.0/24",
    "185.234.10.0/24",
    "185.235.40.0/22",
    "185.235.61.0/24",
    "185.235.247.0/24",
    "185.238.180.0/22",
    "185.239.16.0/22",
    "185.241.124.0/22",
    "185.243.76.0/22",
    "185.244.148.0/23",
    "185.244.151.0/24",
    "185.245.104.0/22",
    "185.251.20.0/24",
    "185.254.66.0/23",
    "186.2.160.0/20",
    "188.64.142.0/24",
    "188.64.162.0/24",
    "188.95.192.0/24",
    "188.116.28.0/22",
    "188.116.36.0/24",
    "188.119.64.0/22",
    "188.119.112.0/22",
    "188.208.103.0/24",
    "188.208.110.0/24",
    "188.212.121.0/24",
    "188.213.0.0/24",
    "188.213.216.0/24",
    "188.214.107.0/24",
    "188.215.31.0/24",
    "188.240.81.0/24",
    "188.240.213.0/24",
    "188.241.84.0/24",
    "188.241.136.0/23",
    "188.241.196.0/23",
    "188.241.221.0/24",
    "188.244.112.0/24",
    "190.115.16.0/20",
    "191.96.0.0/16",
    "191.101.0.0/16",
    "192.58.29.0/24",
    "192.103.14.0/24",
    "192.144.4.0/22",
    "192.144.16.0/22",
    "193.7.200.0/22",
    "193.8.164.0/24",
    "193.8.167.0/24",
    "193.8.171.0/24",
    "193.8.175.0/24",
    "193.9.126.0/24",
    "193.22.228.0/22",
    "193.24.119.0/24",
    "193.27.224.0/23",
    "193.28.183.0/24",
    "193.31.40.0/22",
    "193.32.85.0/24",
    "193.32.188.0/23",
    "193.32.190.0/24",
    "193.33.48.0/24",
    "193.33.102.0/23",
    "193.33.172.0/23",
    "193.33.194.0/23",
    "193.38.50.0/23",
    "193.38.54.0/23",
    "193.42.112.0/22",
    "193.42.120.0/22",
    "193.42.124.0/22",
    "193.47.32.0/23",
    "193.47.34.0/24",
    "193.47.40.0/23",
    "193.53.126.0/23",
    "193.56.134.0/24",
    "193.56.185.0/24",
    "193.56.186.0/24",
    "193.56.188.0/24",
    "193.56.190.0/24",
    "193.58.104.0/22",
    "193.58.119.0/24",
    "193.104.120.0/24",
    "193.107.49.0/24",
    "193.107.208.0/22",
    "193.124.36.0/24",
    "193.124.49.0/24",
    "193.124.80.0/24",
    "193.124.224.0/23",
    "193.135.134.0/23",
    "193.142.253.0/24",
    "193.143.16.0/23",
    "193.148.60.0/23",
    "193.148.63.0/24",
    "193.150.98.0/23",
    "193.150.170.0/23",
    "193.151.176.0/22",
    "193.160.208.0/22",
    "193.163.199.0/24",
    "193.168.131.0/24",
    "193.176.227.0/24",
    "193.178.134.0/24",
    "193.178.169.0/24",
    "193.178.172.0/24",
    "193.178.174.0/24",
    "193.203.105.0/24",
    "193.223.100.0/24",
    "193.228.139.0/24",
    "193.238.132.0/22",
    "193.242.180.0/24",
    "194.5.192.0/23",
    "194.5.206.0/23",
    "194.15.56.0/22",
    "194.31.72.0/22",
    "194.32.96.0/22",
    "194.32.104.0/24",
    "194.32.124.0/22",
    "194.32.222.0/23",
    "194.32.224.0/22",
    "194.32.228.0/22",
    "194.32.248.0/22",
    "194.33.8.0/23",
    "194.34.244.0/22",
    "194.35.112.0/22",
    "194.35.124.0/22",
    "194.36.188.0/24",
    "194.36.190.0/23",
    "194.50.0.0/23",
    "194.50.4.0/23",
    "194.50.170.0/23",
    "194.50.223.0/24",
    "194.50.224.0/24",
    "194.50.233.0/24",
    "194.50.243.0/24",
    "194.53.140.0/22",
    "194.55.102.0/23",
    "194.55.104.0/23",
    "194.58.33.0/24",
    "194.58.34.0/24",
    "194.58.44.0/22",
    "194.59.12.0/24",
    "194.59.40.0/24",
    "194.60.244.0/23",
    "194.61.1.0/24",
    "194.61.76.0/23",
    "194.61.232.0/22",
    "194.62.18.0/24",
    "194.62.19.0/24",
    "194.62.140.0/22",
    "194.69.1.0/24",
    "194.76.15.0/24",
    "194.76.18.0/24",
    "194.76.28.0/24",
    "194.79.60.0/22",
    "194.85.248.0/22",
    "194.93.0.0/22",
    "194.93.28.0/22",
    "194.93.56.0/22",
    "194.104.120.0/24",
    "194.106.196.0/23",
    "194.110.12.0/22",
    "194.110.155.0/24",
    "194.110.242.0/24",
    "194.117.51.0/24",
    "194.135.18.0/24",
    "194.135.30.0/24",
    "194.135.46.0/24",
    "194.135.119.0/24",
    "194.135.124.0/24",
    "194.146.236.0/22",
    "194.147.78.0/23",
    "194.147.84.0/22",
    "194.147.88.0/22",
    "194.147.106.0/23",
    "194.147.110.0/23",
    "194.150.204.0/23",
    "194.150.210.0/23",
    "194.153.153.128/25",
    "194.156.0.0/23",
    "194.156.26.0/23",
    "194.156.92.0/22",
    "194.156.96.0/22",
    "194.156.116.0/22",
    "194.156.120.0/22",
    "194.164.32.0/22",
    "194.164.180.0/24",
    "194.164.220.0/23",
    "194.164.225.0/24",
    "194.165.2.0/23",
    "194.169.84.0/22",
    "194.169.160.0/22",
    "194.170.0.0/16",
    "194.213.16.0/24",
    "194.246.36.0/23",
    "194.247.44.0/23",
    "195.2.86.0/24",
    "195.2.92.0/23",
    "195.2.248.0/24",
    "195.14.2.0/24",
    "195.14.118.0/23",
    "195.18.27.0/24",
    "195.26.224.0/22",
    "195.43.134.0/24",
    "195.60.236.0/24",
    "195.60.237.0/24",
    "195.88.89.0/24",
    "195.95.219.0/24",
    "195.133.192.0/23",
    "195.200.16.0/22",
    "195.200.26.0/24",
    "195.200.28.0/22",
    "195.200.64.0/24",
    "195.229.0.0/16",
    "195.245.102.0/23",
    "195.245.110.0/23",
    "195.246.110.0/23",
    "196.3.67.0/24",
    "196.3.68.0/22",
    "202.71.12.0/22",
    "212.8.251.0/24",
    "212.34.128.0/20",
    "212.34.144.0/21",
    "212.34.152.0/22",
    "212.81.36.0/22",
    "212.107.20.0/22",
    "212.118.36.0/22",
    "212.118.40.0/22",
    "212.118.52.0/22",
    "212.192.0.0/19",
    "212.192.208.0/23",
    "212.192.212.0/22",
    "212.192.218.0/23",
    "213.5.131.0/24",
    "213.42.0.0/19",
    "213.42.32.0/20",
    "213.42.48.0/21",
    "213.42.56.0/24",
    "213.42.57.0/24",
    "213.42.58.0/23",
    "213.42.60.0/22",
    "213.42.64.0/20",
    "213.42.80.0/22",
    "213.42.84.0/22",
    "213.42.88.0/21",
    "213.42.96.0/19",
    "213.42.128.0/17",
    "213.108.4.0/22",
    "213.109.96.0/21",
    "213.109.108.0/22",
    "213.109.168.0/22",
    "213.132.32.0/19",
    "213.134.1.0/24",
    "213.134.11.0/24",
    "213.134.20.0/24",
    "213.139.192.0/22",
    "213.139.200.0/22",
    "213.139.228.0/22",
    "213.166.80.0/22",
    "213.184.92.0/22",
    "213.202.0.0/21",
    "213.217.2.0/23",
    "213.226.100.0/22",
    "213.226.112.0/22",
    "213.226.120.0/22",
    "213.226.124.0/22",
    "217.19.4.0/24",
    "217.60.0.0/16",
    "217.78.233.0/24",
    "217.78.234.0/23",
    "217.78.237.0/24",
    "217.78.238.0/23",
    "217.164.0.0/15"
]
    

        // 阿联酋IPv6地址段
export const uaeIPv6Ranges = [
"2001:67c:2040::/48",
"2001:67c:2348::/48",
"2001:67c:23e8::/48",
"2001:67c:23f0::/48",
"2001:67c:2408::/48",
"2001:67c:259c::/48",
"2001:67c:2654::/48",
"2001:67c:2774::/48",
"2001:67c:29d8::/48",
"2001:7f8:7a::/48",
"2001:8f8::/29",
"2001:df4:1980::/48",
"2001:33c0::/29",
"2602:f783::/40",
"2a00:d30::/32",
"2a00:f28::/29",
"2a00:1b00::/32",
"2a00:68a0::/32",
"2a00:bea0::/32",
"2a00:d1a0::/32",
"2a00:e460::/29",
"2a00:fd80::/32",
"2a01:5f20::/29",
"2a01:75a0::/32",
"2a01:8060::/32",
"2a01:b3a0::/32",
"2a02:1718::/32",
"2a02:f040::/29",
"2a02:f400::/29",
"2a03:660::/32",
"2a03:3a20::/32",
"2a03:4b40::/29",
"2a03:a120::/32",
"2a03:a960::/29",
"2a03:b180::/32",
"2a03:f7c0::/29",
"2a03:fbc0::/29",
"2a03:fd00::/32",
"2a04:23c0::/29",
"2a04:2ec0::/29",
"2a04:63c0::/29",
"2a04:cb80::/29",
"2a04:da00::/29",
"2a04:dd00::/29",
"2a04:ee80::/29",
"2a04:fe40::/29",
"2a05:580::/29",
"2a05:3d40::/29",
"2a05:5e00::/29",
"2a05:6f40::/29",
"2a05:9340::/29",
"2a05:b440::/29",
"2a05:bd80::/29",
"2a05:c500::/29",
"2a06:c40::/29",
"2a06:1ec0::/29",
"2a06:2b80::/29",
"2a06:3d80::/29",
"2a06:5c00::/29",
"2a06:7740::/29",
"2a06:77c0::/29",
"2a06:7840::/29",
"2a06:a780::/29",
"2a06:b180::/29",
"2a06:ddc0::/29",
"2a07:1f00::/29",
"2a07:3700::/29",
"2a07:5c00::/29",
"2a07:98c0::/29",
"2a07:b8c0::/29",
"2a07:bc40::/29",
"2a07:c980::/29",
"2a07:cc40::/29",
"2a09:600::/29",
"2a09:980::/29",
"2a09:a80::/29",
"2a09:e00::/29",
"2a09:f80::/29",
"2a09:1080::/29",
"2a09:1100::/29",
"2a09:1200::/29",
"2a09:1600::/29",
"2a09:1800::/29",
"2a09:1a00::/29",
"2a09:1e00::/29",
"2a09:2000::/29",
"2a09:2380::/29",
"2a09:2480::/29",
"2a09:2a80::/29",
"2a09:2c80::/29",
"2a09:2d00::/29",
"2a09:2f80::/29",
"2a09:3180::/29",
"2a09:31c0::/32",
"2a09:3280::/29",
"2a09:3380::/29",
"2a09:3480::/29",
"2a09:3780::/29",
"2a09:3a80::/29",
"2a09:3f80::/29",
"2a09:4000::/29",
"2a09:4100::/29",
"2a09:4280::/29",
"2a09:4300::/29",
"2a09:4480::/29",
"2a09:4700::/29",
"2a09:4780::/29",
"2a09:4a00::/29",
"2a09:4a80::/29",
"2a09:4b40::/29",
"2a09:4b80::/29",
"2a09:4c80::/29",
"2a09:4d80::/29",
"2a09:4f00::/29",
"2a09:5200::/29",
"2a09:5280::/29",
"2a09:5400::/29",
"2a09:5700::/29",
"2a09:5900::/29",
"2a09:6400::/29",
"2a09:6500::/29",
"2a09:6580::/29",
"2a09:6780::/29",
"2a09:6b00::/29",
"2a09:7400::/32",
"2a09:7680::/29",
"2a09:76c0::/29",
"2a09:7800::/29",
"2a09:7880::/29",
"2a09:7980::/29",
"2a09:7a00::/29",
"2a09:7b80::/29",
"2a09:7bc0::/29",
"2a09:7c80::/29",
"2a09:8000::/29",
"2a09:8100::/29",
"2a09:8440::/29",
"2a09:8800::/29",
"2a09:8980::/29",
"2a09:8bc0::/29",
"2a09:8c80::/29",
"2a09:8d80::/29",
"2a09:8e00::/29",
"2a09:8e80::/29",
"2a09:8f00::/29",
"2a09:8f40::/29",
"2a09:8f80::/29",
"2a09:9100::/29",
"2a09:91c0::/29",
"2a09:9380::/29",
"2a09:9480::/29",
"2a09:9500::/29",
"2a09:9600::/29",
"2a09:9640::/29",
"2a09:9700::/29",
"2a09:9800::/29",
"2a09:9980::/29",
"2a09:9a80::/29",
"2a09:9d80::/29",
"2a09:a100::/29",
"2a09:a600::/29",
"2a09:a880::/29",
"2a09:a980::/29",
"2a09:ae00::/29",
"2a09:b840::/29",
"2a09:b980::/29",
"2a09:bb40::/29",
"2a09:c000::/29",
"2a09:c340::/29",
"2a09:c4c0::/29",
"2a09:cb40::/29",
"2a09:d440::/29",
"2a09:d600::/29",
"2a09:db00::/29",
"2a09:dc80::/29",
"2a09:e000::/29",
"2a09:e3c0::/29",
"2a09:e900::/29",
"2a09:eb00::/29",
"2a09:ed00::/29",
"2a09:efc0::/29",
"2a09:f300::/29",
"2a09:f500::/29",
"2a09:f640::/29",
"2a09:fec0::/29",
"2a0a:6c0::/29",
"2a0a:780::/29",
"2a0a:1f80::/29",
"2a0a:3940::/29",
"2a0a:4e80::/29",
"2a0a:64c0::/29",
"2a0a:77c0::/29",
"2a0a:7a00::/29",
"2a0a:7e00::/29",
"2a0a:8600::/29",
"2a0a:8e00::/29",
"2a0a:9200::/29",
"2a0a:9600::/29",
"2a0a:9a00::/29",
"2a0a:9e00::/29",
"2a0a:9f00::/29",
"2a0a:a600::/29",
"2a0a:a700::/29",
"2a0a:a9c0::/29",
"2a0a:ab40::/29",
"2a0a:b200::/29",
"2a0a:b600::/29",
"2a0a:ba00::/29",
"2a0a:be00::/29",
"2a0a:c1c0::/29",
"2a0a:c500::/29",
"2a0a:c600::/29",
"2a0a:ce00::/29",
"2a0a:d200::/29",
"2a0a:ebc0::/29",
"2a0a:f8c0::/29",
"2a0a:f9c0::/29",
"2a0b:300::/29",
"2a0b:500::/29",
"2a0b:2a80::/29",
"2a0b:2d80::/29",
"2a0b:3300::/29",
"2a0b:3700::/29",
"2a0b:4180::/29",
"2a0b:5780::/29",
"2a0b:58c0::/29",
"2a0b:8040::/29",
"2a0b:8700::/29",
"2a0b:9c80::/29",
"2a0b:ac80::/29",
"2a0b:d900::/29",
"2a0b:e9c0::/29",
"2a0b:f340::/29",
"2a0c:5c0::/29",
"2a0c:2ac0::/29",
"2a0c:3740::/29",
"2a0c:37c0::/29",
"2a0c:38c0::/29",
"2a0c:3980::/29",
"2a0c:4180::/29",
"2a0c:4a80::/29",
"2a0c:5580::/29",
"2a0c:5d00::/29",
"2a0c:65c0::/29",
"2a0c:6980::/29",
"2a0c:7b80::/29",
"2a0c:8580::/29",
"2a0c:9a80::/29",
"2a0c:a280::/29",
"2a0c:ba40::/29",
"2a0c:c180::/29",
"2a0c:db40::/29",
"2a0c:f640::/29",
"2a0c:fa40::/29",
"2a0d:5c0::/29",
"2a0d:a80::/29",
"2a0d:14c0::/29",
"2a0d:1800::/29",
"2a0d:1ac0::/29",
"2a0d:24c0::/29",
"2a0d:28c0::/29",
"2a0d:29c0::/29",
"2a0d:2a40::/29",
"2a0d:2ec0::/29",
"2a0d:2fc0::/29",
"2a0d:34c0::/29",
"2a0d:3f40::/29",
"2a0d:43c0::/29",
"2a0d:4440::/29",
"2a0d:44c0::/29",
"2a0d:4540::/29",
"2a0d:45c0::/29",
"2a0d:4840::/29",
"2a0d:4ac0::/29",
"2a0d:4b40::/29",
"2a0d:4c40::/29",
"2a0d:5ac0::/29",
"2a0d:64c0::/29",
"2a0d:66c0::/29",
"2a0d:6f40::/29",
"2a0d:7040::/29",
"2a0d:7240::/29",
"2a0d:7340::/29",
"2a0d:8480::/29",
"2a0d:8740::/29",
"2a0d:8b40::/29",
"2a0d:8bc0::/29",
"2a0d:9440::/29",
"2a0d:9940::/29",
"2a0d:ab80::/32",
"2a0d:acc0::/29",
"2a0d:b7c0::/29",
"2a0d:b940::/29",
"2a0d:be40::/29",
"2a0d:c080::/29",
"2a0d:c8c0::/29",
"2a0d:d2c0::/29",
"2a0d:dfc0::/29",
"2a0d:e040::/29",
"2a0d:e080::/29",
"2a0d:e140::/29",
"2a0d:f940::/29",
"2a0d:fac0::/29",
"2a0d:fdc0::/29",
"2a0e:200::/29",
"2a0e:c00::/29",
"2a0e:1c00::/29",
"2a0e:2180::/29",
"2a0e:21c0::/29",
"2a0e:2280::/29",
"2a0e:2340::/29",
"2a0e:29c0::/29",
"2a0e:2bc0::/29",
"2a0e:2d00::/29",
"2a0e:2f00::/29",
"2a0e:3340::/29",
"2a0e:34c0::/29",
"2a0e:3580::/29",
"2a0e:3ac0::/29",
"2a0e:3fc0::/29",
"2a0e:4080::/29",
"2a0e:42c0::/29",
"2a0e:43c0::/29",
"2a0e:4b00::/29",
"2a0e:4b40::/29",
"2a0e:4e40::/29",
"2a0e:4ec0::/29",
"2a0e:5500::/29",
"2a0e:61c0::/29",
"2a0e:6940::/29",
"2a0e:6d80::/29",
"2a0e:6e80::/29",
"2a0e:7500::/29",
"2a0e:7540::/29",
"2a0e:7840::/29",
"2a0e:7940::/29",
"2a0e:7a40::/29",
"2a0e:7ac0::/29",
"2a0e:86c0::/29",
"2a0e:8980::/29",
"2a0e:8c40::/29",
"2a0e:8cc0::/29",
"2a0e:90c0::/29",
"2a0e:9240::/29",
"2a0e:9440::/29",
"2a0e:9600::/29",
"2a0e:9640::/29",
"2a0e:a040::/29",
"2a0e:a340::/29",
"2a0e:a740::/29",
"2a0e:b0c0::/29",
"2a0e:b840::/29",
"2a0e:bc80::/29",
"2a0e:bcc0::/29",
"2a0e:bd40::/29",
"2a0e:bdc0::/29",
"2a0e:c040::/29",
"2a0e:c200::/29",
"2a0e:c2c0::/29",
"2a0e:c480::/29",
"2a0e:c540::/29",
"2a0e:c8c0::/29",
"2a0e:cc40::/29",
"2a0e:d440::/29",
"2a0e:d740::/29",
"2a0e:d900::/29",
"2a0e:da00::/29",
"2a0e:df40::/29",
"2a0e:e440::/29",
"2a0e:e4c0::/29",
"2a0e:e680::/29",
"2a0e:e840::/29",
"2a0e:ea40::/29",
"2a0e:efc0::/29",
"2a0e:f040::/29",
"2a0e:f740::/29",
"2a0e:f9c0::/29",
"2a0e:fb00::/29",
"2a0e:fbc0::/29",
"2a0e:fc00::/29",
"2a0f:800::/29",
"2a0f:880::/29",
"2a0f:c80::/29",
"2a0f:ec0::/29",
"2a0f:f00::/29",
"2a0f:1280::/29",
"2a0f:1c00::/29",
"2a0f:1f40::/29",
"2a0f:2600::/29",
"2a0f:26c0::/29",
"2a0f:2780::/29",
"2a0f:2c00::/29",
"2a0f:3200::/29",
"2a0f:3ac0::/29",
"2a0f:4000::/29",
"2a0f:4140::/29",
"2a0f:4540::/29",
"2a0f:5200::/29",
"2a0f:5500::/29",
"2a0f:5600::/29",
"2a0f:59c0::/29",
"2a0f:5a00::/29",
"2a0f:5a40::/29",
"2a0f:5cc0::/29",
"2a0f:5d00::/29",
"2a0f:5d80::/29",
"2a0f:5f00::/29",
"2a0f:6000::/29",
"2a0f:6100::/29",
"2a0f:6240::/29",
"2a0f:6340::/29",
"2a0f:65c0::/29",
"2a0f:6640::/29",
"2a0f:6800::/29",
"2a0f:6900::/29",
"2a0f:71c0::/29",
"2a0f:7440::/29",
"2a0f:7d80::/29",
"2a0f:7e40::/29",
"2a0f:8280::/29",
"2a0f:8440::/29",
"2a0f:8800::/29",
"2a0f:8c40::/29",
"2a0f:8d80::/29",
"2a0f:8e00::/29",
"2a0f:9480::/29",
"2a0f:94c0::/29",
"2a0f:9500::/29",
"2a0f:9dc0::/29",
"2a0f:9e40::/29",
"2a0f:9ec0::/29",
"2a0f:a280::/29",
"2a0f:a380::/29",
"2a0f:a480::/29",
"2a0f:a600::/29",
"2a0f:aa00::/29",
"2a0f:ab80::/29",
"2a0f:ae00::/29",
"2a0f:b380::/29",
"2a0f:b600::/29",
"2a0f:b740::/29",
"2a0f:b800::/29",
"2a0f:b840::/29",
"2a0f:c880::/29",
"2a0f:d080::/29",
"2a0f:d400::/29",
"2a0f:dc00::/29",
"2a0f:e300::/29",
"2a0f:e500::/29",
"2a10:2100::/32",
"2a10:4240::/29",
"2a10:5d40::/29",
"2a10:79c0::/29",
"2a10:8e00::/29",
"2a10:9580::/29",
"2a10:bb80::/29",
"2a10:d280::/29",
"2a10:e840::/32",
"2a10:f840::/29",
"2a11:40::/29",
"2a11:340::/29",
"2a11:1b80::/29",
"2a11:1cc0::/29",
"2a11:2100::/29",
"2a11:26c0::/29",
"2a11:2940::/29",
"2a11:2b40::/29",
"2a11:2e80::/29",
"2a11:2f00::/29",
"2a11:3580::/29",
"2a11:3b00::/29",
"2a11:3d40::/29",
"2a11:3e00::/29",
"2a11:4080::/29",
"2a11:4900::/29",
"2a11:4b00::/29",
"2a11:5400::/29",
"2a11:6900::/29",
"2a11:6a80::/29",
"2a11:6d80::/29",
"2a11:6f80::/29",
"2a11:7500::/29",
"2a11:7c00::/29",
"2a11:7f00::/29",
"2a11:8800::/29",
"2a11:9800::/29",
"2a11:9c80::/29",
"2a11:a280::/29",
"2a11:bb80::/29",
"2a11:bf00::/29",
"2a11:c0c0::/29",
"2a11:c180::/29",
"2a11:cf00::/29",
"2a11:d200::/29",
"2a11:d500::/29",
"2a11:d600::/29",
"2a11:d900::/29",
"2a11:da00::/29",
"2a11:dc80::/29",
"2a11:f480::/29",
"2a11:fc00::/29",
"2a12:3c0::/29",
"2a12:4bc0::/29",
"2a12:4c40::/29",
"2a12:4cc0::/29",
"2a12:4d40::/29",
"2a12:4dc0::/29",
"2a12:4fc0::/29",
"2a12:53c0::/29",
"2a12:54c0::/29",
"2a12:55c0::/29",
"2a12:5640::/29",
"2a12:7840::/29",
"2a12:8c80::/29",
"2a12:a880::/29",
"2a12:e700::/29",
"2a12:ed80::/29",
"2a13:a80::/29",
"2a13:3300::/29",
"2a13:4980::/29",
"2a13:4b80::/29",
"2a13:5200::/29",
"2a13:5dc0::/29",
"2a13:8a40::/29",
"2a13:90c0::/29",
"2a13:97c0::/29",
"2a13:b6c0::/29",
"2a13:ba80::/29",
"2a13:f080::/29",
"2a14:780::/29",
"2a14:1000::/29",
"2a14:1e00::/29",
"2a14:48c0::/29",
"2a14:5280::/29",
"2a14:6b80::/29",
"2a14:6e40::/32",
"2a14:9d00::/29",
"2a14:b000::/29",
"2a14:d580::/29",
"2a14:f500::/29"
]